import React from "react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

type FieldWarningProps = {
  children: React.ReactNode;
};

const FieldWarning: React.FC<FieldWarningProps> = ({ children }) => (
  <div
    role="note"
    className="mt-2 rounded bg-yellow-200 p-2 text-sm text-yellow-700"
  >
    <ExclamationTriangleIcon className="mr-1 inline-block h-5 w-5" />
    {children}
  </div>
);

export default FieldWarning;
